jQuery( document ).ready(function( jQuery ) {
  console.log();
   jQuery('.right_image .image[image-name="angel-classic"]').addClass("image_on").show();
  jQuery('.our_collections .left_links ul li a').mouseover(function(){
                console.log(this);  
    let theAnchor = jQuery(this).attr("image-name");
      
      jQuery(".right_image .image").each(function(num,value){
             console.log(this);
      jQuery(this).removeClass("image_on").hide();
          let name = jQuery(value).attr("image-name");
         if (name == theAnchor) {
     jQuery(this).addClass("image_on").show();
           
        }
        
      });
  });
  jQuery('body').removeClass('popup_active');
  jQuery('.popup_images .category-link').click(function(){
      var parent = jQuery(this).parent();
      var section_popup_images = jQuery(parent).find('.section_popup_images');
      console.log(section_popup_images);
      if (section_popup_images.length) {
      	  jQuery('body').addClass('popup_active');
    	  jQuery(parent).find('.section_popup_images').addClass('image_popup_active');
      }
     
  });
  jQuery('.popup_images .section_popup_images_overlay , .close').click(function(){
       jQuery('body').removeClass('popup_active');
       jQuery('body').find('.section_popup_images').removeClass('image_popup_active');
  });
jQuery(document).on('keyup',function(evt) {
    if (evt.keyCode == 27) {
        jQuery('body').removeClass('popup_active');
       jQuery('body').find('.section_popup_images').removeClass('image_popup_active');
    }
});
  
 jQuery('.section_popup_images .all_popup_images').owlCarousel({
      margin:10,
      nav:true,
      responsive:{
          0:{
              items:1
          },
          600:{
              items:1
          },
          1000:{
              items:1
          }
      }
  });
});